package io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.Icons

public val Icons.FacebookSimpleIcons: ImageVector
    get() {
        if (_facebookSimpleIcons != null) {
            return _facebookSimpleIcons!!
        }
        _facebookSimpleIcons = Builder(name = "FacebookSimpleIcons", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(9.10f, 23.69f)
                verticalLineToRelative(-7.98f)
                horizontalLineTo(6.63f)
                verticalLineToRelative(-3.67f)
                horizontalLineToRelative(2.47f)
                verticalLineToRelative(-1.58f)
                curveToRelative(0.0f, -4.09f, 1.85f, -5.98f, 5.86f, -5.98f)
                curveToRelative(0.40f, 0.0f, 0.96f, 0.04f, 1.47f, 0.10f)
                arcToRelative(8.68f, 8.68f, 0.0f, false, true, 1.14f, 0.20f)
                verticalLineToRelative(3.33f)
                arcToRelative(8.62f, 8.62f, 0.0f, false, false, -0.65f, -0.04f)
                arcToRelative(26.81f, 26.81f, 0.0f, false, false, -0.73f, -0.01f)
                curveToRelative(-0.71f, 0.0f, -1.26f, 0.10f, -1.68f, 0.31f)
                arcToRelative(1.69f, 1.69f, 0.0f, false, false, -0.68f, 0.62f)
                curveToRelative(-0.26f, 0.42f, -0.37f, 1.00f, -0.37f, 1.75f)
                verticalLineToRelative(1.30f)
                horizontalLineToRelative(3.92f)
                lineToRelative(-0.39f, 2.10f)
                lineToRelative(-0.29f, 1.56f)
                horizontalLineToRelative(-3.25f)
                verticalLineToRelative(8.25f)
                curveTo(19.40f, 23.24f, 24.0f, 18.18f, 24.0f, 12.04f)
                curveToRelative(0.0f, -6.63f, -5.37f, -12.0f, -12.0f, -12.0f)
                reflectiveCurveToRelative(-12.0f, 5.37f, -12.0f, 12.0f)
                curveToRelative(0.0f, 5.63f, 3.87f, 10.35f, 9.10f, 11.65f)
                close()
            }
        }
        .build()
        return _facebookSimpleIcons!!
    }

private var _facebookSimpleIcons: ImageVector? = null
